type StorageKeys = 'likes_left'|'notif_perm'|'fcm_token'|'currentImChatMeta'|'geolocation'|'name'|'blockList'

class LocalStorageService{

    updateStorage(key: StorageKeys, value: any){
        if(typeof(value) == 'object')
         value = JSON.stringify(value)

        localStorage.setItem(key, value)
    }

    getItem(key: StorageKeys){
        if (!('Notification' in window))
         return null
        return localStorage.getItem(key)
    }

    removeItem(key: StorageKeys){
        localStorage.removeItem(key)
    }

    getPubKey(key: string){
        return localStorage.getItem(key)
    }

    updatePubKey(key: string, value: string){
        localStorage.setItem(key, value)
    }

    removePubKey(key: string){
        localStorage.removeItem(key)
    }

    clearAll(){
        localStorage.clear()
    }


}

export default new LocalStorageService()